import $ from 'jquery'

import sanitizer from '@app/adapters/sanitizer'
import sanitizeXhrModalHtml from '@app/utils/sanitize-xhr-modal-html'

const mapAccounts = (data, includeValues = false) => {
  let children = data.map((group) => group.children).flat()
  children = children.filter((c) => c.id !== null)
  const mappedAccounts = children.map((item) => {
    item.formattedText = formattedText(item, includeValues)
    item.id = item.value
    return item
  })

  return mappedAccounts
}

const formattedText = (item, includeValues = false) => {
  if (item.text) return item.text

  return `<div class="sf-level sf-level-small ${
    includeValues ? 'sf-level-between' : ''
  }">
              <div class="sf-level-item sf-level-item-full">
                  <div class="sf-c-text-light">${originalIdentifier(item)}</div>
                  <div class="sf-font-m sf-c-text-dark sf-fwdb">${
                    item.label
                  }</div>
              </div>
              ${
                includeValues
                  ? `<div class="sf-level-item">${item.actual_value}</div>`
                  : ''
              }
          </div>`
}

const formattedTextWithValues = (item) => {
  if (item.text) return item.text

  return `<div class="sf-level sf-level-between sf-pad-r-2">
              <div>${item.label}</div>
              <div>${item.actual_value}</div>
            </div>
          </div>`
}

const originalIdentifier = (item) => {
  let identifier = ''
  if (item.original_number) identifier += `${item.original_number} `
  if (item.original_name) identifier += `${item.original_name} `
  if (identifier === '') identifier = item.label
  return identifier
}

const setInitialValue = ($select) => {
  const selectedValue = $select.attr('data-selected-label')
  if (!selectedValue) return

  const selectedText = $select.attr('data-selected-text')
  const selectedAccount = {
    value: selectedValue,
    title: selectedText,
    text: formattedTextWithValues({
      label: selectedText,
      actual_value: $select.attr('data-selected-value'),
    }),
  }
  const $option = $('<option>', selectedAccount)
  $select.append($option).trigger('change')
  $select.trigger({
    type: 'select2:select',
    params: {
      data: [selectedAccount],
    },
  })
}

const fetchComparisonTable = (
  ledgerId,
  accountNumber,
  originalEntryId,
  originalAccountId,
  successCallback = null,
  postRequest = false,
  disableActions = false
) => {
  const urlParams = [
    Silverfin.currentFirmId,
    Silverfin.currentCompanyId,
    ledgerId,
    accountNumber,
  ]

  const url = postRequest
    ? Silverfin.Routes.ledger_comparative_reconciliation_path(...urlParams)
    : Silverfin.Routes.ledger_reconciliation_comparison_table_path(...urlParams)

  $.ajax({
    url: url,
    method: postRequest ? 'post' : 'get',
    data: {
      original_account_id: originalAccountId,
      original_entry_id: originalEntryId,
      disable_actions: disableActions,
    },
  }).done(function (data) {
    $('.detail-section').html(sanitizeXhrModalHtml(data))

    if (successCallback) successCallback()
  })
}

onDomLoad(function ($dom) {
  $dom.find("[data-behavior='ledger-account-select2']").each((_, item) => {
    const $select = $(item)
    const autocompleteUrl = `/f/${Silverfin.currentFirmId}/${Silverfin.currentCompanyId}/accounts/autocomplete`
    const ledgerId = $select.data('ledger-id')
    const profitAndLoss = $select.data('p-and-l')
    const balanceSheet = $select.data('balance-sheet')

    $select.select2({
      selectOnClose: true,
      placeholder: {
        id: -1,
        label: 'Select an account',
      },
      width: '100%',
      theme: 'silverfin',
      escapeMarkup: (markup) => sanitizer(markup),
      templateResult: (item) => item.formattedText,
      templateSelection: function (account) {
        if (account.id === -1)
          return `<div class="sf-level sf-level-small"><div class="sf-level-item sf-level-item-full"><div class="sf-level-item">${account.label}</div></div></div>`

        return ledgerId
          ? formattedTextWithValues(account)
          : formattedText(account)
      },
      ajax: {
        url: autocompleteUrl,
        dataType: 'json',
        data: (params) => ({
          q: params.term,
          ledger_id: ledgerId,
          p_and_l: profitAndLoss,
          balance_sheet: balanceSheet,
        }),
        processResults: (data) => ({
          results: mapAccounts(data, !!ledgerId),
        }),
      },
    })

    setInitialValue($select)
  })

  $dom
    .find("[data-behaviour='reconciliation-comparison-section']")
    .each(function () {
      const $this = $(this)
      const dataAttrs = $this.data()
      const $spinner = $this.find('i.fa-spinner')
      $spinner.removeClass('sf-hidden')
      const ledgerId = dataAttrs.ledgerId || Silverfin.currentLedgerId()
      fetchComparisonTable(
        ledgerId,
        dataAttrs.accountNumber,
        dataAttrs.originalEntryId,
        dataAttrs.originalAccountId,
        () => {
          $spinner.addClass('sf-hidden')
        },
        false,
        Boolean(dataAttrs.disableActions)
      )
    })
})

$(document).ready(function () {
  window.eventHub.$on('account-selector-opened', () => {
    $('.btn-account-picker-submit').on('click', (e) => {
      e.preventDefault()
      const accountNumber = $('#account_number').val()

      if (accountNumber === null) {
        $('.sf-modal-close').click()
      } else {
        const $btn = $(e.target)
        const ledgerId = $btn.data('ledger-id')
        const originalEntryId = $btn.data('original-entry-id')
        const originalAccountId = $(
          "[data-behaviour='reconciliation-comparison-section']"
        ).data('original-account-id')

        fetchComparisonTable(
          ledgerId,
          accountNumber,
          originalEntryId,
          originalAccountId,
          () => {
            $('.sf-modal-close').click()
          },
          true
        )
      }
    })
  })
})
